module.exports = __webpack_public_path__ + "static/media/b_queen.93f7b07f.png";